import { HTTPClient } from '@abaco/web-common/src/HTTP';

export default class PrincesWidgetsAPI {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getMosiStocks(pkCuaa: number, type: string, params: any){
        if(params) {
            Object.keys(params).forEach((param: string) => {
                params[param] = [null, ''].includes(params[param]) ? null : params[param];
            })
        }
        
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/mosi/${type}/${pkCuaa}/stocks`, {params});
        return res.data
    }
}
